import {
  Dialog,
  Box,
  Typography,
  IconButton,
  Tooltip,
  useTheme,
  Skeleton,
} from "@mui/material";
import { useEffect, useState } from "react";
import CloseOutlinedIcon from "@mui/icons-material/CloseOutlined";
import WifiIcon from "@mui/icons-material/Wifi";
import WifiOffIcon from "@mui/icons-material/WifiOff";
import LanOutlinedIcon from "@mui/icons-material/LanOutlined";
import RouterOutlinedIcon from "@mui/icons-material/RouterOutlined";
import SettingsEthernetOutlinedIcon from "@mui/icons-material/SettingsEthernetOutlined";
import DevicesOtherOutlinedIcon from "@mui/icons-material/DevicesOtherOutlined";
import InfoOutlinedIcon from "@mui/icons-material/InfoOutlined";
import useStyles from "./styles";
import api from "../../../../services/api";

export default function ModalConexaoDetails(params) {
  const {
    open,
    handleClose = () => {},
    serviceId,
    clienteId,
    isOnline,
    setSnackbar = () => {},
  } = params;
  const theme = useTheme();
  const styles = useStyles(theme);
  const [loading, setLoading] = useState(false);
  const [conexao, setConexao] = useState(null);

  useEffect(() => {
    if (!open || !serviceId) return;
    let active = true;
    async function fetchConexaoDetails() {
      setLoading(true);
      try {
        const response = await api.post("/interno/findConexaoDetails", {
          serviceId,
          clienteId,
        });
        if (active) setConexao(response?.data || null);
      } catch (error) {
        console.error("Erro ao buscar detalhes da conexão:", error);
        if (active) setConexao(null);
      } finally {
        if (active) setLoading(false);
      }
    }
    fetchConexaoDetails();
    return () => {
      active = false;
      setConexao(null);
    };
  }, [open, serviceId]);

  async function handleCopy(value) {
    if (!value) return;
    try {
      await navigator.clipboard.writeText(value);
    } catch (err) {
      const textArea = document.createElement("textarea");
      textArea.value = value;
      document.body.appendChild(textArea);
      textArea.select();
      try {
        document.execCommand("copy");
      } catch (err) {
        console.error("Falha ao copiar texto: ", err);
      }
      document.body.removeChild(textArea);
    }
    setSnackbar({ children: "Campo copiado!", severity: "info" });
  }

  const fields = [
    {
      key: "ipNas",
      label: "NAS",
      icon: LanOutlinedIcon,
      value: conexao?.ipNas,
    },
    {
      key: "equipConexao",
      label: "Equipamento de Conexão",
      icon: RouterOutlinedIcon,
      value: conexao?.equipConexao,
    },
    {
      key: "nasPortId",
      label: "NAS Port ID",
      icon: SettingsEthernetOutlinedIcon,
      value: conexao?.nasPortId,
    },
    {
      key: "callingStationId",
      label: "Calling Station ID (MAC)",
      icon: DevicesOtherOutlinedIcon,
      value: conexao?.callingStationId,
    },
  ];

  const semDados = !loading && fields?.every((field) => !field.value);

  return (
    <Dialog open={open} onClose={handleClose} PaperProps={{ sx: styles.paper }}>
      <Box sx={styles.header}>
        <Box sx={styles.headerTitleBox}>
          <Box sx={styles.headerIconBox(isOnline)}>
            {isOnline ? (
              <WifiIcon fontSize="small" />
            ) : (
              <WifiOffIcon fontSize="small" />
            )}
          </Box>
          <Box>
            <Typography variant="subtitle1" fontWeight="bold">
              Detalhes da Conexão
            </Typography>
            <Typography variant="caption" color="text.secondary">
              {isOnline ? "Online" : "Offline"}
            </Typography>
          </Box>
        </Box>
        <IconButton size="small" onClick={handleClose} aria-label="Fechar">
          <CloseOutlinedIcon fontSize="small" />
        </IconButton>
      </Box>

      <Box sx={styles.content}>
        {loading ? (
          [...Array(4)].map((_, index) => (
            <Skeleton
              key={index}
              variant="rounded"
              height={54}
              sx={{ borderRadius: 2 }}
            />
          ))
        ) : semDados ? (
          <Box sx={styles.emptyState}>
            <InfoOutlinedIcon />
            <Typography variant="body2">
              Nenhum detalhe de conexão disponível.
            </Typography>
          </Box>
        ) : (
          fields.map(({ key, label, icon: Icon, value }) => (
            <Box key={key} sx={styles.fieldRow}>
              <Icon sx={styles.fieldIcon} />
              <Box sx={styles.fieldTextBox}>
                <Typography sx={styles.fieldLabel}>{label}</Typography>
                <Tooltip title="Clique para copiar">
                  <Typography
                    sx={styles.fieldValue}
                    onClick={() => handleCopy(value)}
                  >
                    {value || "-"}
                  </Typography>
                </Tooltip>
              </Box>
            </Box>
          ))
        )}
      </Box>
    </Dialog>
  );
}
